<template>
  <div class="container-options-setting-dialog">
    <div class="content-group-default">
      <el-collapse v-model="activeNames" @change="handleChange">
        <!--        <el-collapse-item title="开启定位" name="1">-->
        <el-collapse-item v-if="inDocument !== 'none'" title="开启定位" name="1">
          <div class="mb24">
            <span class="mr8">开启定位</span>
            <el-switch v-model="isFixed" active-color="#3D82F2" @change="changeBgSetStatu"></el-switch>
          </div>
          <!--                  <double-input-->
          <!--                    v-if="isFixed"-->
          <!--                    class="mb16"-->
          <!--                    title="尺寸"-->
          <!--                    placeHolderText="必填"-->
          <!--                    :value1.sync="width"-->
          <!--                    :value2.sync="height"-->
          <!--                    :inputSuffixs="['宽', '高']"-->
          <!--                  />-->
          <div class="content mb16" v-if="isFixed && inDocument === 'none'">
            <div class="fs14 mb16">位置</div>
            <div class="fixed-position-set">
              <single-input
                class="pos-offset-inp pos-offset-top"
                :disabled="offsetStatu.topDisabled"
                :value.sync="marginTop"
                :noInputSuffixs="true"
              />
              <single-input
                class="pos-offset-inp pos-offset-right"
                :disabled="offsetStatu.rightDisabled"
                :value.sync="marginRight"
                :noInputSuffixs="true"
              />
              <single-input
                class="pos-offset-inp pos-offset-bottom"
                :disabled="offsetStatu.bottomDisabled"
                :value.sync="marginBottom"
                :noInputSuffixs="true"
              />
              <single-input
                class="pos-offset-inp pos-offset-left"
                :disabled="offsetStatu.leftDisabled"
                style="width: 80px; height: 28px"
                :value.sync="marginLeft"
                :noInputSuffixs="true"
              />
            </div>
          </div>
          <div class="content-item mb16" v-if="isFixed && inDocument === 'none'">
            <div class="border-radius-header">
              <el-checkbox v-model="borderRadiusChecked" @change="checkboxHandle(1, '')">圆角</el-checkbox>
              <div v-show="borderRadiusChecked" class="border-radius-btn">
                <span
                  class="icon-portal-full-screen1"
                  :class="borderTypeFlag == 1 ? 'select' : ''"
                  @click="changeBorderRadiusType(1, '')"
                ></span>
                <span
                  class="icon-portal-adjustment1"
                  :class="borderTypeFlag == 2 ? 'select' : ''"
                  @click="changeBorderRadiusType(2, '')"
                ></span>
              </div>
            </div>
            <div v-show="borderRadiusChecked">
              <div v-if="borderTypeFlag == 1">
                <div class="verticallyCenter mt16">
                  <div class="radius_bg_1 mr16 ml24"></div>
                  <el-slider
                    :show-tooltip="false"
                    class="mr16"
                    style="width: 192px; height: 4px"
                    v-model="borderTopLeftRadius"
                  ></el-slider>
                  <single-input
                    style="width: 80px; height: 28px"
                    :value.sync="borderTopLeftRadius"
                    inputSuffixs="px"
                  />
                </div>
                <div class="verticallyCenter mt16">
                  <div class="radius_bg_2 mr16 ml24"></div>
                  <el-slider
                    class="mr16"
                    style="width: 192px; height: 4px"
                    :show-tooltip="false"
                    v-model="borderTopRightRadius"
                  ></el-slider>
                  <single-input
                    style="width: 80px; height: 28px"
                    :value.sync="borderTopRightRadius"
                    inputSuffixs="px"
                  />
                </div>
                <div class="verticallyCenter mt16">
                  <div class="radius_bg_3 mr16 ml24"></div>
                  <el-slider
                    class="mr16"
                    style="width: 192px; height: 4px"
                    v-model="borderBottomRightRadius"
                    :show-tooltip="false"
                  ></el-slider>
                  <single-input
                    style="width: 80px; height: 28px"
                    :value.sync="borderBottomRightRadius"
                    inputSuffixs="px"
                  />
                </div>
                <div class="verticallyCenter mt16">
                  <div class="radius_bg_4 mr16 ml24"></div>
                  <el-slider
                    class="mr16"
                    style="width: 192px; height: 4px"
                    v-model="borderBottomLeftRadius"
                    :show-tooltip="false"
                  ></el-slider>
                  <single-input
                    style="width: 80px; height: 28px"
                    :value.sync="borderBottomLeftRadius"
                    inputSuffixs="px"
                  />
                </div>
              </div>
              <div v-else class="verticallyCenter mt16">
                <el-slider
                  class="mr16 ml24"
                  style="width: 192px; height: 4px"
                  :show-tooltip="false"
                  v-model="borderRadius"
                ></el-slider>
                <single-input
                  style="width: 80px; height: 28px"
                  :value.sync="borderRadius"
                  inputSuffixs="px"
                />
              </div>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item title="尺寸" name="2" v-if="!isPhoneFullScreen">
          <div class="verticallyCenter">
            <span class="fs14 mr8 color000">高度</span>
            <single-input
              class="size-inp mr8"
              placeholder="请输入高度"
              :value.sync="height"
              inputSuffixs="px"
            />
          </div>
        </el-collapse-item>
        <el-collapse-item title="外观" name="3">
          <cx-background :background.sync="background" imgType="10" />
        </el-collapse-item>
        <!-- <el-collapse-item v-if="$route.path === '/home' && currContainer.options.inDocument" title="自适应" name="4">
          <div v-if="currContainer.children.length">
            <div v-if="currContainer.options.inDocument === 'header'">
              <div v-for="(val, k) in primaryHeadContainerRect" :key="k" :data-k="11 + k" class="mt8">
                <cx-select
                  clearable
                  :popper-class="'containerSetting' + 'headComponentMap' + 'k'"
                  :title="primaryHeadContainerRectNames[k]"
                  :selectOptions="filterRect(rectInContainerOptions, k)"
                  :value="val"
                  @change="changeContainerPrimaryRect('headComponentMap', k, $event)"
                  @visible-change="selectVisibleChange('containerSetting' + 'headComponentMap' + 'k', $event)"
                />
              </div>
            </div>
            <div v-else-if="currContainer.options.inDocument === 'footer'">
              <div v-for="key in primaryBottomContainerRect" :key="key"></div>
            </div>
          </div>
        </el-collapse-item> -->
      </el-collapse>
    </div>
  </div>
</template>

<script>
import defaultImage from "../../../assets/images/image_placeholder.png"
import { getAttrById } from "../../../utils"
import defaultBgImage from "../../../assets/images/default_image.png"
import { componentNames } from "dependencies/base"
const basePrimaryHeadContainerRect = {
  nav: "",
  logo: "",
  login: ""
}
const primaryHeadContainerRectNames = {
  nav: "导航",
  logo: "logo",
  login: "登录"
}
const basePrimaryBottomContainerRect = {
  doc: null,
  location: null,
  tel: null
}
const primaryBottomContainerRectNames = {
  doc: "文档",
  location: "地址",
  tel: "电话"
}
export default {
  name: "container-options-setting",
  data() {
    return {
      defaultImage: defaultImage,
      this1: this,
      primaryHeadContainerRectNames,
      primaryBottomContainerRectNames,
      activeNames: ["1", "2"],
      defaultBgImage: defaultBgImage,
      activeType: 1,
      checked: true,
      borderTypeFlag: 1,
      borderRadiusChecked: true,
      tabsActive: 0, //  显示背景还是背景图片
      predefineColors: [
        "#0047FF",
        "#00E4E4",
        "#FFA63F",
        "#D627B0",
        "#C035E3",
        "#802CF5",
        "#8BFF4A",
        "#FFA429",
        "#FF5C5A",
        "#FF58C7",
        "#53FFAC",
        "#FFF91F",
        "#41FFD1",
        "#6D5CFF",
        "#0089FF",
        "#FF6969",
        "#83FF7D",
        "#4EDBFF",
        "#E3FF59",
        "#B700FF"
      ],
      alignTypeList: [],
      activeRectId: null
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    currContainer() {
      return getAttrById(this.$store.state[this.request_prefix], { container_id: this.ids.container_id })
    },
    primaryHeadContainerRect: {
      get() {
        //获取头部画布的默认组件
        const container = this.currContainer
        const res = this.checkAndSetPrimaryVal(container, "options.headComponentMap", "primaryHeadContainerRect", {
          ...basePrimaryHeadContainerRect
        })
        console.log("res :>> ", container.options.headComponentMap, res)
        return res
      },
      set(val) {
        this.$store.dispatch(this.request_prefix + "/changeContainerAttribute", {
          key: "options.headComponentMap",
          data: val,
          containerId: this.ids.container_id
        })
      }
    },
    primaryBottomContainerRect: {
      get() {
        //获取底部画布的默认组件
        const container = this.currContainer
        return this.checkAndSetPrimaryVal(container.options, "bottomComponentMap", "primaryBottomContainerRect", {
          ...basePrimaryBottomContainerRect
        })
      },
      set(val) {
        this.$store.dispatch(this.request_prefix + "/changeContainerAttribute", {
          key: "options.bottomComponentMap",
          data: val,
          containerId: this.ids.container_id
        })
      }
    },
    rectInContainerOptions() {
      const res = []
      this.$store.state[this.request_prefix].page.children[0].children.forEach(rect => {
        res.push({
          label: componentNames[rect.shape],
          value: rect.rect_id,
          rect
        })
      })
      console.log("res :>> ", res)
      return res
    },
    offsetStatu() {
      let topDisabled = false,
        bottomDisabled = false,
        leftDisabled = false,
        rightDisabled = false
      switch (this.positionType) {
        case "left top":
          bottomDisabled = true
          rightDisabled = true
          break
        case "left center":
          bottomDisabled = true
          rightDisabled = true
          break
        case "center top":
          bottomDisabled = true
          rightDisabled = true
          break
        case "center center":
          bottomDisabled = true
          rightDisabled = true
          break
        case "right top":
          bottomDisabled = true
          leftDisabled = true
          break
        case "right center":
          bottomDisabled = true
          leftDisabled = true
          break
        case "left bottom":
          topDisabled = true
          rightDisabled = true
          break
        case "center bottom":
          topDisabled = true
          rightDisabled = true
          break
        case "right bottom":
          topDisabled = true
          leftDisabled = true
          break
        default:
      }
      return { topDisabled, bottomDisabled, leftDisabled, rightDisabled }
    },
    width: {
      get() {
        return getAttrById(this.$store.state[this.request_prefix], { container_id: this.ids.container_id }).width
      },
      set(newVal) {
        this.$store.dispatch(this.request_prefix + "/changeContainerAttribute", {
          key: "width",
          data: newVal,
          containerId: this.ids.container_id
        })
      }
    },
    height: {
      get() {
        return getAttrById(this.$store.state[this.request_prefix], { container_id: this.ids.container_id }).height
      },
      set(newVal) {
        this.$store.dispatch(this.request_prefix + "/changeContainerAttribute", {
          key: "height",
          data: newVal,
          containerId: this.ids.container_id
        })
      }
    },
    inDocument: {
      get() {
        return this.getOptions.inDocument || "none"
      },
      set(newVal) {
        if (newVal !== "none") {
          this.width = 1920
        }
        this.$changeOptionsEV(newVal, "inDocument", false)
      }
    },
    borderTopLeftRadius: {
      get() {
        return this.getOptions.borderTopLeftRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopLeftRadius", false)
      }
    },
    borderTopRightRadius: {
      get() {
        return this.getOptions.borderTopRightRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopRightRadius", false)
      }
    },
    borderBottomRightRadius: {
      get() {
        return this.getOptions.borderBottomRightRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomRightRadius", false)
      }
    },
    borderBottomLeftRadius: {
      get() {
        return this.getOptions.borderBottomLeftRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomLeftRadius", false)
      }
    },
    borderRadius: {
      get() {
        return this.getOptions.hasOwnProperty("borderBottomLeftRadius") ? this.getOptions.borderBottomLeftRadius : 0
      },
      set(newVal) {
        this.$changeOptionsEV(
          [newVal, newVal, newVal, newVal],
          ["borderTopLeftRadius", "borderTopRightRadius", "borderBottomRightRadius", "borderBottomLeftRadius"],
          false
        )
      }
    },
    marginLeft: {
      get() {
        return this.getOptions.hasOwnProperty("marginLeft") ? this.getOptions.marginLeft : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "marginLeft", false)
      }
    },
    marginRight: {
      get() {
        return this.getOptions.hasOwnProperty("marginRight") ? this.getOptions.marginRight : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "marginRight", false)
      }
    },
    marginTop: {
      get() {
        return this.getOptions.hasOwnProperty("marginTop") ? this.getOptions.marginTop : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "marginTop", false)
      }
    },
    marginBottom: {
      get() {
        return this.getOptions.hasOwnProperty("marginBottom") ? this.getOptions.marginBottom : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "marginBottom", false)
      }
    },
    openBgSet: {
      get() {
        return this.getOptions.openBgSet || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "openBgSet", false)
      }
    },
    isFixed: {
      get() {
        return this.getOptions.isFixed || false
      },
      set(newVal) {
        if (!newVal) {
          this.width = 1920
        }
        this.$changeOptionsEV(newVal, "isFixed", false)
        this.$store.dispatch(this.request_prefix + "/countContainerHeight")
      }
    },
    background: {
      get() {
        let background = this.getOptions.background
        if (background && Array.isArray(background) && background.length > 0) {
          return this.getOptions.background
        }
        let newBackground = []
        let defalutColor = this.request_prefix === "stage" ? "#fff" : "#00043A"
        newBackground.push({
          type: "color",
          label: "颜色",
          isThemeColor: false,
          color: this.getOptions.bgColor || defalutColor
        })
        this.$changeOptionsEV(newBackground, "background", false, false, false, true)
        return newBackground
      },
      set(val) {
        this.$changeOptionsEV(val, "background", false)
      }
    },
    getOptions: function () {
      if (!this.$getOptions() || this.$getOptions().length === 0) {
        return {}
      } else {
        return this.$getOptions()
      }
    },
    // 翻页模板
    isPhoneFullScreen() {
      return this.$store.state[this.request_prefix].page.isPhoneFullScreen
    }
  },
  methods: {
    filterRect(rects, k) {
      let res = null
      switch (k) {
        case "nav":
          res = rects.filter(currRect => {
            const { rect } = currRect
            return rect.shape === "cxNavMenu"
          })
          break
        case "logo":
          res = rects.filter(currRect => {
            const { rect } = currRect
            return rect.shape === "imageComponent"
          })
          break
        case "login":
          res = rects.filter(currRect => {
            const { rect } = currRect
            return (
              rect.shape === "emptyLayoutComponent" &&
              rect.options.pluginName &&
              rect.options.pluginName.find(name => name === "loginLayoutComponent")
            )
          })
          break

        default:
          break
      }
      return res
    },
    selectVisibleChange(name, visible) {
      if (visible) {
        this.watchSelectOpt(name)
      } else {
        this.delWatchSelectOpt(name)
      }
    },
    watchSelectOpt(name) {
      this.$nextTick(() => {
        const selects = document.getElementsByClassName(name)
        Array.prototype.find
          .call(selects, el => el.style.display !== "none")
          .addEventListener("mouseover", this.handleSelectMouseover, true)
      })
    },
    delWatchSelectOpt(name) {
      const selects = document.getElementsByClassName(name)
      Array.prototype.find
        .call(selects, el => el.style.display !== "none")
        .removeEventListener("mouseover", this.handleSelectMouseover, true)
      if (this.activeRectId !== null) {
        this.$store.commit(this.request_prefix + "/DISABLE_ACTIVE", {
          container_id: this.ids.container_id,
          rect_id: this.activeRectId
        })
        this.activeRectId = null
      }
    },
    handleSelectMouseover(e) {
      if (e.target.classList.contains("el-select-dropdown__item")) {
        const rect_id = Number(e.target.dataset.value)
        this.activeRectId = rect_id
        this.$store.dispatch(this.request_prefix + "/setActive", {
          container_id: this.ids.container_id,
          rect_id
        })
      }
    },
    changeContainerPrimaryRect(type, name, rect_id) {
      console.log(rect_id, 1)
      this.$store.dispatch(this.request_prefix + "/changeContainerAttribute", {
        key: `options.${type}.${name}`,
        data: rect_id,
        containerId: this.ids.container_id
      })
      console.log("primaryHeadContainerRect :>> ", this.primaryHeadContainerRect)
    },
    handleMouseover(event) {
      console.log(event.target.className)
      if (event.target.className === "el-select-dropdown__item hover") {
      }
    },
    // 切换当前tab激活项
    changeActiveHandle(event, flag) {
      event.stopPropagation()
      this.tabsActive = flag
    },
    switchHandle(type) {
      this.activeType = type
    },
    changePositionType(value) {
      if (value === "center center") {
        return
      }
      this.positionType = value
    },
    changeBorderRadiusType(value) {
      this.borderTypeFlag = value
    },
    changeBgSetStatu() {},
    handleChange() {},
    getFocus(event) {
      event.currentTarget.select()
    }
  }
}
</script>

<style scoped>
.title {
  position: relative;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.8);
}
.unfold-btn {
  width: 20px;
  height: 20px;
  background-image: url("../../../assets/images/arrows-up.png");
  transform: rotateY(90deg);
  position: absolute;
  top: 0;
  right: 0;
}
.fold-btn {
  width: 20px;
  height: 20px;
  background-image: url("../../../assets/images/arrows-up.png");
  position: absolute;
  top: 0;
  right: 0;
}

.icon-portal-full-screen1.select::before {
  color: #ffffff;
}
.icon-portal-adjustment1.select::before {
  color: #ffffff;
}
.border-image {
  width: 200px;
}
.content .upload {
  width: 160px;
  height: 90px;
}
.card {
  display: block;
  padding: 16px;
  background: #f7f7f7;
  border-radius: 4px;
  border: none;
}
.setting-item .content-item .options {
  font-size: 14px;
  line-height: 20px;
  color: rgba(0, 0, 0, 0.8);
}
.fixed-position-ul {
  width: 60px;
  box-shadow: 0 0 1px #999;
}
.fixed-position-ul > li {
  margin: 2px;
}
.fixed-position-ul > li:nth-child(5) {
  opacity: 0;
}
.pos-offset-inp {
  width: 40px;
  height: 32px;
  position: absolute;
}
.pos-offset-inp/deep/ .el-input__inner {
  padding: 5px 2px;
  text-align: center;
}
.fixed-position-set {
  position: relative;
  display: inline-block;
  padding: 60px;
  box-sizing: border-box;
}
.pos-offset-top {
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
}
.pos-offset-right {
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
}
.pos-offset-bottom {
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
}
.pos-offset-left {
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
}
.size-inp {
  width: 100px;
  height: 32px;
  margin-right: 20px;
}
.single-input {
  flex: 1;
}
</style>
